/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { isAxiosError } from 'axios';

export const isRetryableError = (failureCount: number, error: unknown): boolean => {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 503) {
      return failureCount < 3;
    }
    if (status === 429) {
      return true;
    }
  }
  return false;
};

export const isRetryableBVError = (failureCount: number, error: unknown): boolean => {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    if (status === 404) {
      return failureCount < 3;
    }
    if (status === 429) {
      return true;
    }
  }
  return false;
};
